export default {
  costingList: {
    method: 'post',
    url: '/costing/list'
  },
  getCostingDetail: {
    method: 'get',
    url: '/costing/detail/ID'
  },
  updateCosting: {
    method: 'put',
    url: '/costing/update/ID'
  },
  deleteCosting: {
    method: 'DELETE',
    url: '/costing/delete/ID'
  },
  archiveCosting: {
    method: 'DELETE',
    url: '/costing/archive'
  },
  restoreCosting: {
    method: 'PUT',
    url: '/costing/restore'
  }
}
